import { type ObjectValuesUnionType } from '../../../utils/typing';

export const KLComfortIds = Object.freeze({
  PIZZA: 'PIZZA',
  CHOCOLATE: 'CHOCOLATE',
  HOTEL: 'HOTEL',
});
export type KLComfortId = ObjectValuesUnionType<typeof KLComfortIds>;

export const ObfKLComfortIds = Object.freeze({
  [KLComfortIds.PIZZA]: 1,
  [KLComfortIds.CHOCOLATE]: 2,
  [KLComfortIds.HOTEL]: 3,
});

export const ReverseObfKLComfortIds = Object.freeze({
  '1': [KLComfortIds.PIZZA],
  '2': [KLComfortIds.CHOCOLATE],
  '3': [KLComfortIds.HOTEL],
});

export const KLCollectibleIds = Object.freeze({
  // Tribu rouge
  WATER: 'WATER',
  RICE: 'RICE',
  FISHING: 'FISHING',
  FIRECAMP: 'FIRECAMP',
  HUT: 'HUT',

  // Tribu blanche
  GRAND_BLUE: 'GRAND_BLUE',
  BALANCE: 'BALANCE',
  DUO: 'DUO',
  SLOTH: 'SLOTH',
  BAMBOOS: 'BAMBOOS',

  // Orientation
  MARK: 'MARK',
  TAG: 'TAG',
  KNIFE: 'KNIFE',

  // Comforts
  ...KLComfortIds,

  // Collar
  COLLAR: 'COLLAR',
});
export type KLCollectibleId = ObjectValuesUnionType<typeof KLCollectibleIds>;

export const ObfKLCollectibleIds = Object.freeze({
  [KLCollectibleIds.WATER]: 1,
  [KLCollectibleIds.RICE]: 2,
  [KLCollectibleIds.FISHING]: 3,
  [KLCollectibleIds.FIRECAMP]: 4,
  [KLCollectibleIds.HUT]: 5,

  [KLCollectibleIds.GRAND_BLUE]: 6,
  [KLCollectibleIds.BALANCE]: 7,
  [KLCollectibleIds.DUO]: 8,
  [KLCollectibleIds.SLOTH]: 9,
  [KLCollectibleIds.BAMBOOS]: 10,

  [KLCollectibleIds.MARK]: 11,
  [KLCollectibleIds.TAG]: 12,
  [KLCollectibleIds.KNIFE]: 13,
});

export const ReverseObfKLCollectibleIds = Object.freeze({
  '1': KLCollectibleIds.WATER,
  '2': KLCollectibleIds.RICE,
  '3': KLCollectibleIds.FISHING,
  '4': KLCollectibleIds.FIRECAMP,
  '5': KLCollectibleIds.HUT,

  '6': KLCollectibleIds.GRAND_BLUE,
  '7': KLCollectibleIds.BALANCE,
  '8': KLCollectibleIds.DUO,
  '9': KLCollectibleIds.SLOTH,
  '10': KLCollectibleIds.BAMBOOS,

  '11': KLCollectibleIds.MARK,
  '12': KLCollectibleIds.TAG,
  '13': KLCollectibleIds.KNIFE,
});

export const KLCollectibleStatuses = Object.freeze({
  OPEN: 'OPEN', // Achievement open
  PENDING: 'PENDING', // Bet pending for this achievement
  WON: 'WON', // Achievement won
  LOST: 'LOST', // Achievement
  CANCELLED: 'CANCELLED',

  MISS: 'MISS', // /!\ Custom value computed by front
});
export type KLCollectibleStatus = ObjectValuesUnionType<typeof KLCollectibleStatuses>;

export const KLRound1CollectibleIds: Array<KLCollectibleId> = [
  KLCollectibleIds.WATER,
  KLCollectibleIds.RICE,
  KLCollectibleIds.FISHING,
  KLCollectibleIds.FIRECAMP,
  KLCollectibleIds.HUT,
];

export const KLRound2CollectibleIds: Array<KLCollectibleId> = [
  KLCollectibleIds.DUO,
  KLCollectibleIds.GRAND_BLUE,
  KLCollectibleIds.SLOTH,
  KLCollectibleIds.BAMBOOS,
  KLCollectibleIds.BALANCE,
];

export const KLRound3CollectibleIds: Array<KLCollectibleId> = [
  KLCollectibleIds.MARK,
  KLCollectibleIds.TAG,
  KLCollectibleIds.KNIFE,
];

export const KLCollectiblesSortedByRound = [KLRound1CollectibleIds, KLRound2CollectibleIds, KLRound3CollectibleIds];
